import * as React from 'react';
import 'url-search-params-polyfill';
import api from '../../../api';

import { FeaturedContainer } from '@travelnest/merlin.featured-container';
import { Loader } from '@travelnest/merlin.loader';
import { IPayLater } from 'api/payLater';
import { useLocation } from 'react-router';
import { PayLaterResponseDisplay } from './PayLaterResponseDisplay';

export const useQuery = () => {
	return new URLSearchParams(useLocation().search);
};

export const getEventId = () => {
	const eventId = useLocation().pathname.toString().split('/').pop();
	if (eventId === null || typeof eventId === 'undefined') {
		throw new Error('Invalid event Id');
	}
	return eventId;
};
export const getHash = () => {
	const hash = useQuery().get('h');
	if (hash === null || typeof hash === 'undefined') {
		throw new Error('Invalid hash');
	}
	return hash;
};

export const PayLater: React.FC = () => {
	const [loading, setLoading] = React.useState(true);
	const [response, setResponse] = React.useState<IPayLater>();

	const eventId = getEventId();
	const hash = getHash();

	const fetchData = async () => {
		try {
			const result = await api.paylater.sendPayLaterEvent(eventId, {
				hash,
			});
			setLoading(false);
			setResponse(result);
		} catch (err) {
			setLoading(false);
			setResponse(err.data.body);
		}
	};

	React.useEffect(() => {
		fetchData();
	}, []);

	return <PayLaterView loading={loading} response={response} />;
};

interface IPayLaterViewProps {
	loading: boolean;
	response?: IPayLater;
}

export const PayLaterView: React.FC<IPayLaterViewProps> = (props) => {
	const { loading, response } = props;

	return (
		<FeaturedContainer>
			<h1>Payment Delay Registration</h1>
			{loading || response === undefined ?
				<div data-testid="-loader" style={{ height: '100px' }}>
					<Loader loading={true} />
				</div>
				:
				<PayLaterResponseDisplay response={response} />
			}
		</FeaturedContainer>
	);
};
